import ajax from '../../../mobile/utils/ajax';
import proFetch from "../../../mobile/utils/project-fetch";

/**
 * h5登录，得看看ucg有没有可能提供一个账号密码登录方法
 * @param params
 * @returns {Promise<unknown>}
 */
function login(params) {
    return new Promise((resolve, reject) => {
        resolve({
            success: true
        })
    })
}

function callAction({
                        success,
                        error,
                        ...params
                    }
) {
    ajax({
        ...params,
        success: (res) => {
            if (res.success) {
                res.code = '200';
                success(res);
            } else {
                error(res);
            }
        },
        error: (err) => {
            if (err && err.data && err.data.error) {
                error(err.data.error);
            } else {
                error(err)
            }
        }
    })
}

function upload(data) {
    return new Promise((resolve, reject) => {
        const {body, ...config} = data;
        proFetch({
            data: body,
            loading: false,
            noNeedShowError: true,
            ...config,
        }).then((res) => {
            resolve(res);
        }).catch((err) => {
            reject(err);
        })
    });
}

let acts = [
    {
        api: 'login',
        fn: login
    },
    {
        api: 'callAction',
        fn: callAction
    },
    {
        api: 'upload',
        fn: upload
    }
]

export default acts;